/*!
 *
 *  slider.ts
 *
 */
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
export default function (elem) {
    new Swiper(elem, {
        modules: [Navigation, Pagination, EffectFade],
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 700,
        loop: true,
        effect: 'fade',
        navigation: {
            nextEl: '#top-hero-next',
            prevEl: '#top-hero-prev',
        },
        pagination: {
            el: '#top-hero-pagination',
            clickable: true,
        },
    });
}
